import {
	DEFAULT_CLOUD_GRAPH_CUSTOMER_CONTACT_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
} from '../../entities';
import {
	NounSubtypeKey,
	type TypeFilterValue3PEntities,
	TypeFilterValueKey,
} from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { SalesforceIcon } from './icon';
import { SalesforceIconBorderless } from './icon-borderless';
import { SalesforceSearchResultIcon } from './search-result-icon';

const getSalesforce3PTypeFilterConfig = () => {
	const config = new Map<TypeFilterValueKey, TypeFilterValue3PEntities>();
	config.set(TypeFilterValueKey.CustomerOrg, {
		entities3P: DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI,
		subTypes3P: [],
	});
	config.set(TypeFilterValueKey.Deal, {
		entities3P: [
			...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
			...DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI,
		],
		subTypes3P: [NounSubtypeKey.Deal],
	});
	config.set(TypeFilterValueKey.CustomerContact, {
		entities3P: [...DEFAULT_CLOUD_GRAPH_CUSTOMER_CONTACT_ENTITY_ATI],
		subTypes3P: [],
	});
return config;
};

export const salesforceConfig: ThirdPartyConfig = {
	displayName: 'Salesforce',
	id: 'salesforce',
	resourceType: 'salesforce-connector',
	icon: get3PLogo(SalesforceIcon, 'Salesforce', 'medium'),
	iconBorderless: get3PLogo(SalesforceIconBorderless, 'Salesforce', 'small'),
	searchResultIcon: get3PLogo(SalesforceSearchResultIcon, 'Salesforce', 'large'),
	integrationAri: 'ari:cloud:platform::integration/salesforce',
	typeFilterConfig: getSalesforce3PTypeFilterConfig(),
	filters: ['lastUpdated', 'onlyTitleMatch', 'lastUpdatedBy', 'createdBy'],
	requiresOauth: true,
	isEnabled: () => true,
};
